// extracted by mini-css-extract-plugin
export default {"VisitUs":"style_VisitUs__NU0Yk","container":"style_container__1uX26","socialsWrap":"style_socialsWrap__tp+Lo"};